import React from "react";
import { AccountRulePresence } from "@common/types/domains/accounting/account";
import { AccountingReportFilters } from "../types";

export const AccountRulePresenceFilterLabel: React.FC<{
    filters: AccountingReportFilters;
}> = ({ filters }) => (
    <>
        {filters.accountRulePresence === AccountRulePresence.HAS_RULE
            ? "Has rules"
            : "No rules"}
    </>
);
